module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "CHAPTER 4"
    }
  }, [_c('p', {
    staticClass: "h2-c",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch4"
    }
  }, [_vm._v("CHAPTER 4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h2-c1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch4"
    }
  }, [_vm._v("THE FRESHMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_c('i', [_vm._v("“I’m willing to be ineffective in the short run if it means in the long run, we’re able to build a majority.”")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("1979")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("ewt Gingrich hadn’t even been sworn into his first term in Congress, but that didn’t stop him from gaining a little national publicity. In December 1978, a month and change after winning the election, he called for the expulsion of Michigan congressman Charles Diggs, along with Pennsylvania congressman Daniel Flood, both mossy-backed Democrats. Government corruption was as old as the Republic, and a time-honored tradition in Congress, as witnessed in the recent ABSCAM probe by the FBI—using agents wearing burnooses, posing as Arab sheiks, and carrying briefcases full of cash—rooting out more corrupt members of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In one memorable videotaped scene, a Republican member of Congress, Richard Kelly of Florida, was seen stuffing the cash into his pockets and under his pants while another congressman, Mike Myers of Pennsylvania, got into a shoving match with his aide over who would take the bribe and how much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelly was the only Republican snared in ABSCAM; all the others were Democrats, nearly all from either New Jersey or Pennsylvania. Congressman John Murtha of Pennsylvania almost took the cash, too, but balked at the last minute, though he kept the door open for future discussion by indicating that he wanted to “do business” with the sheiks in the future. When the charges were handed down, Murtha was listed as an “unindicted co-conspirator”—a term Americans had become familiar with during Watergate—and only saved his political hide when he turned stool pigeon for the state against two of his indicted colleagues."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn1",
      "id": "c4_fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("Capitol Hill also remained awash in “Koreagate” rumors, in which members of Congress were taking cash and gifts from a South Korean lobbyist to gain “influence.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn2",
      "id": "c4_fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Attention focused on Tongsun Park, lobbyist for the South Korean government, but investigators believed the Congress-buying spree went all the way to the president of South Korea."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn3",
      "id": "c4_fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When it came to the corruption of the era, Flood and Diggs were no pikers. Flood was standing trial for accepting bribes totaling $100,000, and Diggs had already been convicted on twenty-nine counts of receiving kickbacks from his staff in the amount of $60,000."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn4",
      "id": "c4_fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Both Flood and Diggs had been reelected despite the stench around them. Both were Democrats. Congressman-elect Gingrich was taking on the majority party and the insular congressional establishment. He wasn’t even in office yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve been in Washington and heard guys the last two weeks saying you’ve got to play along and that he [Diggs] isn’t doing anything so bad, and he needed the money. That’s insanity—how can you say guys who make the laws should be excused from felony counts,” Gingrich said."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn5",
      "id": "c4_fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ironically, Jack Flynt, whom Gingrich had lost to twice and whom he would soon succeed, was still the lame-duck chair of the House Ethics Committee for another month. Since he was an ally of House Speaker Tip O’Neill, and since many of the House members charged with corruption were Democrats, clean government groups charged Flynt with sweeping most of his committee’s investigations under the carpet."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn6",
      "id": "c4_fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" No crusading reformer, Flynt understood a previous House Speaker’s edict, “to get along, go along.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of the initial Koreagate investigation beginning in 1977, Flynt dissembled to reporters, “I can’t say anymore about it, because it’s an element of an ongoing investigation.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn7",
      "id": "c4_fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Over the charge that dozens of members were on the take from the South Korean government, he simply said he’d “uncovered no evidence to support such figures.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn8",
      "id": "c4_fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Flynt, however, promised to issue subpoenas for “persons with Asian names.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn9",
      "id": "c4_fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flynt was also disinterested in looking deeper into the charges against Diggs and Flood. Diggs was black, which made the whole thing even touchier. The entire Congressional Black Caucus—all sixteen members—dug in their heels in defense of their friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gingrich had a lot to learn about Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His friends at the black-owned "), _c('i', [_vm._v("Atlanta Daily World")]), _vm._v(" gave him a warm sendoff, noting he was “the first Republican to represent the Sixth . . . "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("since the Reconstruction Period.” Gingrich hosted a breakfast for around a hundred fellow Georgians, “mostly a cross section of Black leaders” that “were apparently impressed by this freshman congressman . . . This is an unprecedented breakfast. In our 50-year-history we do not remember any other Congressman or U.S. Senator coming . . . to host a meal . . . so soon after taking office.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn10",
      "id": "c4_fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was actually worse than the "), _c('i', [_vm._v("Daily World")]), _vm._v(" realized. In all the years Jack Flynt had been a part of Georgia’s congressional delegation, he never once held a leadership breakfast, because he refused to sit at the same table with Andrew Young, the black congressman from Atlanta."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn11",
      "id": "c4_fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gingrich pledged his support for a holiday for the slain Dr. Martin Luther King Jr. and introduced his interracial staff to the breakfast meeting. The newspaper was filled with comments from constituents and community leaders praising the young former professor, though he did slip into a bit of pander-mode when he “lamented the lack of black pictures in Washington. ‘There are 861 statues and paintings in the Capitol. There are zero black ones.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn12",
      "id": "c4_fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gingrich’s ’78 election was a major breakthrough for the GOP in Georgia, and yet a number of local Republicans were disquieted by his campaign. Some Republicans had been rumored to be miffed and quietly voted for Virginia Shapard. He ruffled a few more feathers by passing over both Carlyle Gregory and Chip Kahn for the top position in his congressional office, opting instead for a young man by the name of Bob Weed, who Gingrich told the "), _c('i', [_vm._v("Newman Times")]), _vm._v("-"), _c('i', [_vm._v("Herald")]), _vm._v(" was the “most successful campaign manager in Virginia Republican history.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn13",
      "id": "c4_fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gingrich was also almost obsessive about his House taping machine, into which he recorded his thoughts and musings almost daily. Staff were carefully assigned to take care of the tapes and detailed memos were handed out to insure the taping machine operated smoothly."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn14",
      "id": "c4_fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tapings would eventually be used as briefing tapes on campaigns and campaign strategies that were widely distributed to GOP challengers. Part of his team at the time was an obscure pollster, Dick Morris, years before he became a close advisor to Bill Clinton. Gingrich was obsessed with many things, but most especially the politics of politics."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn15",
      "id": "c4_fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He also authored a very detailed and comprehensive memo describing left-wing “smears,” including those against Robert Bork, Ed Meese, and Ray "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("Donovan. Understanding how it worked and the mechanics behind such campaigns “will then help prove our point that a group of vicious, irresponsible, and morally corrupt power hungry left wingers are willing to say and do anything to retain their power against the will of the American people,” Gingrich wrote."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn16",
      "id": "c4_fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 96th Congress, which arrived in January 1979, was impressive. Along with Gingrich, other newly minted congressmen included Richard B. Cheney of Wyoming, Geraldine Ferraro of New York, Phil Gramm of Texas, Don Albosta of Michigan, Tony Coelho of California, Olympia Snowe of Maine, Richard Shelby of Alabama, Jim Sensenbrenner of Wisconsin, Bill Nelson of Florida, Ron Paul of Texas, Kent Hance (who had defeated a young George W. Bush) also of Texas, and several others who would go on to political fame."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn17",
      "id": "c4_fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The class of ’78 also contained some real “Peter Principle” politicians, including Democrat Michael Barnes of Maryland and Republicans Jon Hinson of Mississippi, Dan Crane of Illinois, and Joel Deckard of Indiana."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn18",
      "id": "c4_fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" All would go on to embarrass their constituents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The section at the back of the House floor where the members from the South gathered was inelegantly referred to as “Redneck Row.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn19",
      "id": "c4_fn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Newton Leroy Gingrich joined Redneck Row on January 3, 1979."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn20",
      "id": "c4_fn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The overwhelming numbers of this informal group’s members from below the Mason-Dixon line were still Democrats, but conservative in many regards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gingrich won appointment to the Committee on House Administration. There he found himself at an immediate political advantage: House Administration had supervision over the in-House budget. Putting Gingrich on this committee was akin to letting a fox loose in the henhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bureaucracy of Washington—including Capitol Hill—had grown exponentially over the previous decade. A chronic critic of wasteful government spending, the legendary Democrat Bill Proxmire, a senator from Wisconsin, “noted that over the past decade, the number of congressional aides had increased from 10,700 to 18,400 and the congressional payroll soared from $150 million to $550 million.” Proxmire, who sponsored the monthly “Golden Fleece Award” for the most wasteful government program, said, “Senators and staff are stumbling over themselves.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn21",
      "id": "c4_fn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Gingrich would follow Proxmire’s lead in the House: “I’ll use this committee to carry on my fight to clean up Congress and help lower fiscal spending.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn22",
      "id": "c4_fn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("Gingrich settled into his duties, but was keeping up his relentless pursuit of Charles Diggs, a task made easier by his role as Ethics Committee chairman and the departure from Congress of his predecessor Jack Flynt. The new congressman from the Sixth District was the only member of the Georgia delegation supporting expulsion. Tip O’Neill and the Democratic House continued to drag their feet. In mid-January 1979, only days after being sworn in, Gingrich was circulating a letter asking “the House Ethics Committee to investigate whether there are grounds to expel Diggs from Congress.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn23",
      "id": "c4_fn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Fourteen Republicans signed up; so, too, did Congressman Dick Gephardt of Missouri, an up-and-coming Democrat."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn24",
      "id": "c4_fn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a moment of incredible audacity, he sent another letter directly to Diggs, threatening him with expulsion if he tried to cast a vote on the House floor. Gingrich had been in Congress for less than a month.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Days later, the upstart Georgian was published in the op-ed pages of the "), _c('i', [_vm._v("Washington Post")]), _vm._v(", making his case against Diggs, pointing out that the Detroit congressman had already “been tried, convicted, and sentenced to three years in prison,” yet was still roaming the halls of Congress and still voting. “Frankly, I don’t think we can tolerate the idea of a convicted felon making law.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn25",
      "id": "c4_fn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his original conviction, “a jury of 10 black women, one black man and a white man” convicted him “on 29 felony charges.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn26",
      "id": "c4_fn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Opinion in the African American community was sharply divided. In Diggs’s hometown of Detroit, the Reverend Charles Williams of the Saint Mark Baptist Church supported Diggs’s expulsion and sent a group to Washington to meet with their congressman and call for him to step down. Conversely, the head of the National Postal Alliance, Robert L. White, supported Diggs. Some noted, “The only problem is that if Diggs serves time, then his constituents will not be represented during that time.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn27",
      "id": "c4_fn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Congressman Parrin Mitchell of Maryland, former head of the Black Caucus, had his own take on representation: “The will of the people—that’s what the House is all about. If they want to elect Hitler or a Klansman, it’s their right.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn28",
      "id": "c4_fn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In closing his piece in the "), _c('i', [_vm._v("Post")]), _vm._v(", Gingrich quoted from a letter Jefferson had written to John Adams, extolling the new American Republic and saying that it would be “founded on principles of honesty.” He also cautioned that “either force or corruption has been the principle of every modern "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("government.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn29",
      "id": "c4_fn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" The short piece meandered off the topic of Diggs; clearly Gingrich was attempting to impress Washington’s denizens with his grasp of history.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Capitol Hill was still paying only slight attention to Gingrich, but this would change quickly. In order to redress the inequity of the exemption congressmen enjoyed by not having to participate in the bankrupt Social Security system, Gingrich fulfilled a campaign promise and introduced his first bill, calling for an end to the preferential system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The first bill I’m introducing requires Congressmen to pay their fair share of the Social Security tax they passed.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn30",
      "id": "c4_fn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" The scheme Congress had come up with for itself was appalling, to say the least. Under their own privileged system, federal employees—including elected officials—paid in $26,000 over their lifetime and once they retired, would receive $22,000 per year for the rest of their lives. The crassly generous returns were not based on superior investments; instead, they were subsidized by the US taxpayer. “If they paid it themselves, they might understand the pain it causes hard-working families when they are hit by both inflation and Social Security tax increases.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn31",
      "id": "c4_fn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leading by example, Gingrich opted out of the corrupt system even though, as a young man, he said it “might cost me from $130,000 to $300,000 if I’m reelected and live a long life.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn32",
      "id": "c4_fn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He introduced it on the House floor as H.R. 2339 and “was referred to the Committee on Ways and Means.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn33",
      "id": "c4_fn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The bill covered only twenty-nine lines on the House document, but to the entrenched establishment it might as well have been a declaration of war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He also co-sponsored H.R. 1598 at the end of January, “To provide for permanent tax rate reductions for individuals.” The bill was sponsored by Jack Kemp and co-sponsored by several dozen of the best and brightest of the upcoming crop of young conservatives in the House, including Barry Goldwater Jr. of California."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn34",
      "id": "c4_fn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("On the evening of Friday, January 26, 1979, two years after his unhappy and partial term as vice president ended, Nelson Aldrich Rockefeller was unexpectedly struck down by a heart attack."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn35",
      "id": "c4_fn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" He’d been governor of New York for four terms and had sought the GOP presidential nomination, sometimes "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("desultorily, sometimes aggressively, in 1960, 1964, and 1968. His candidacies, except in 1964, were mostly a figment of the New York and Washington political establishment’s imagination. He was, in fact, too liberal, too overbearing, too Eastern Establishment, too rich, too cosmopolitan, and too divorced. His second marriage in 1963 to Margaretta “Happy” Large Fitler Murphy—who had been betrothed to an old friend—and her early pregnancy had done nothing to improve his chances. Nor had it endeared him to the increasingly conservative GOP that loved Barry Goldwater.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The evening of his death, Rocky had dined with Happy, and returned—it was reported at the time—to his office at Rockefeller Center, ostensibly to work on an art book. Rumors swirled around Republican circles that Rocky was really working on his young assistant, with whom he had been having an affair. He had first met the young woman when she was hired on his press staff while he was serving as vice president to Gerald Ford.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rocky had had a major coronary while "), _c('i', [_vm._v("in flagrante delicto")]), _vm._v(" with his young aide. She was much smaller than he and, for a time, she could not get out from under him. Finally she did, but called neither the police nor an ambulance. Instead, she called her girlfriend, Ponchitta Pierce, a New York television personality."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn36",
      "id": "c4_fn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Reports at the time indicated that although he was first stricken at 10:15 p.m., the assistant did not call for an ambulance until 11:16."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn37",
      "id": "c4_fn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rockefeller’s limo driver had dropped him off at 25 West 54th Street around 10:00 p.m. Media reports initially said Rocky was at his office at Rockefeller Center that night, but in fact, the ambulance found the stricken man at 13 West 54th Street, next door to the woman’s home at 25 West 54th Street. Rockefeller owned both buildings."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn38",
      "id": "c4_fn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A longtime Rockefeller aide, Hugh Morrow, appeared and tried to assemble what was left of the old man’s dignity before the paramedics, the police, and the cream of the New York media showed up. However, by the time they arrived, he was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rocky was cremated eighteen hours after his death, the family refused an autopsy, and the young woman went into hiding."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn39",
      "id": "c4_fn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" At 4:00 a.m., reporters knocked on her door, but she would not speak to them except to confirm that Morrow was in her apartment, obviously trying to clean up the public relations mess left for him by his old boss."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn40",
      "id": "c4_fn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The twenty-five-year-old, who that night was seen wearing a “long black "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("evening gown,” melted into the ether of history. She was to receive $50,000 and a Manhattan townhouse in Rockefeller’s will."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn41",
      "id": "c4_fn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A comedy of errors ensued as no one seemed to get the story right as to how and under what circumstances Rocky died. Both the young woman and Pierce were put under what amounted to house arrest by the family’s many PR operatives, and neither was allowed to talk to the media. Outside of the hospital where Rocky had been taken, Morrow told a gaggle of snickering reporters, “He was having a wonderful time with the whole art enterprise. He was having a ball.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn42",
      "id": "c4_fn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Rockefeller’s was a brand of Republicanism that was all but gone in the GOP. Internationalism and big government activism with a social conscience, a political philosophy that he embraced, was out. In his time as governor of New York, the state budget had gone from roughly $2 billion to almost $9 billion. Taxes had increased in that same time from $94 to $460 for every man, woman, and child in the state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cream of the East Coast elite turned out for the funeral of the über–East Coast elitist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was lauded by all, including President and Mrs. Carter, who attended the services with Vice President Mondale, former president Ford, and other dignitaries from the political, philanthropic, and international communities. Richard Nixon did not attend, but he did pay a sympathy call on Mrs. Rockefeller. In character, he said Rocky was a “tough guy.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn43",
      "id": "c4_fn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The embarrassing circumstances of Rockefeller’s death added colorful symbolism to the corruption rampant in the old-style Republicanism the former vice president embodied. Gingrich’s aggressive public relations campaign to present himself as the face of a new kind of Republicanism could not have been more timely. What a few days earlier had appeared impertinent and audacious, now began to seem almost cathartic. Gingrich slowly picked up more public support in his drive to oust Diggs. By the prerogative of the House he could force a vote, but he needed forty-three GOP representatives—10 percent of the House—to do so. There were plenty ready to support him, but Gingrich’s initiative did not even come close to getting the support of all his fellow Republicans, a commentary on the insiderism of the era. Artfully, the House Democrats stalled for time on the resolution, which "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("prevented Diggs himself from voting and bought themselves some breathing room to figure out how to handle the hot potato.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ultimately, they handled it by standing with Diggs and telling Gingrich to stick it: they refused to stop the convicted congressman from voting in committee or on the floor while his appeal was under consideration. Gingrich raised the stakes by calling for Diggs’s expulsion outright, but Diggs was defended passionately by Majority Leader Jim Wright, who said expulsion was “the most severe punishment the House can bestow.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn44",
      "id": "c4_fn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Only three members had ever been expelled from the House, and all three expulsions took place during the Civil War, when the offending members had joined the Congress of the Confederacy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On March 1, Gingrich introduced House Resolution 142, “To expel Charles C. Diggs, Jr., of Michigan.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn45",
      "id": "c4_fn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early March, Gingrich’s resolution was voted on. “The freshman Republican’s resolution was referred to the Ethics Committee by a vote of 322–77, where it was tabled and subsequently died.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn46",
      "id": "c4_fn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Bluster was one thing, but an on-the-record vote for a convict was another. Previously, the Democratic caucus voted to support Diggs—but on a voice vote that was not recorded. And of the 276 members of that Democratic caucus, only 82 showed up the day the vote of caucus support was scheduled to voice their opinions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn47",
      "id": "c4_fn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("The matter dragged on for three more months, until June, when Diggs finally admitted to his fellow members that he had taken $40,000 in kickbacks, promised to repay them, and reluctantly accepted a censure by the House, the first in sixty years. “In July 1979 the House voted unanimously to censure Mr. Diggs, who had remained free on appeal, after half an hour of floor discussion in which no one spoke in his defense.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn48",
      "id": "c4_fn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plan was for Diggs to pay back the embezzled monies at the rate of $500 per month plus interest, which Tom Edsall of the "), _c('i', [_vm._v("Baltimore Sun")]), _vm._v(" noted “would take more than seven years.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn49",
      "id": "c4_fn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Diggs’s court appeal failed. He served fourteen months of a three-year sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gingrich won plaudits for his tenaciousness and drive for reform, but he also created as many enemies on both sides of the aisle for embarrassing their beloved institution. One lifetime enemy he made then and there "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("was Texan Jim Wright, House majority leader, who had a strong taste for destroying his political enemies. Gingrich had been in the House precisely six months and had already managed to tick off its most vindictive member. Of Wright, Bob Livingston, a member from New Orleans and friend of Gingrich’s, said, “He was imperious . . . a sense of entitlement, of being in the majority forever and the Republicans were peons.” Of Newt, he said, “He was fearless.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn50",
      "id": "c4_fn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("In July, the young back-bencher and some fellow political climbers pushed Republican National Committee chairman Bill Brock on how to wage political war against Jimmy Carter. Meeting with Tory party officials in Washington, Gingrich learned how the British conservatives, tired of losing, undertook a fifteen-month effort to unseat Prime Minister James Callaghan and replace him with Margaret Thatcher. The economic conditions in Great Britain were atrocious, thus making the Tories’ job easier, but Brock, Gingrich, and the GOP were impressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They began their own efforts, aimed at Carter, focused on their own budget proposal but centered on massive tax cuts for the individual. Out of the box, they labeled Carter’s a “budget of despair” and theirs a “budget of hope.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn51",
      "id": "c4_fn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Talking about hope was not something the Republicans had much experience with in the past. That had been the domain of the Democratic Party since FDR.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brock’s RNC, along with the NRCC and the GOP Senatorial Committee, had come a long way. All had risen from the ashes of the post-Watergate landscape, in which GOP donations had dried up and the so-called election reforms had chased big givers into submission. Freed of the yoke of Nixon and Ford, and with Carter to push against, the committees were reborn into impressive operations for recruitment, research, fund-raising, and morale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They still had to fend off GOP members of Congress who tried to foist their ne’er-do-well children off on the committee. Various “Muffies” and “Buffies” and “Skips” and other offspring, including professional inheritors, took up time, space, and money at the RNC. It was this “preppie” deadwood that Brock was determined to clean out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Republicans were on offense and it felt good. Gingrich went so far "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("as to publicly suggest a coalition government in the House, where the GOP would caucus with Southern conservative Democrats and overthrow House Speaker Tip O’Neill. It wasn’t realistic, but it was a good indicator of the mood among the GOPers. Surprisingly, “a half-dozen or so conservative Democrats [took] Gingrich up on his invitation to join in a coalition.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn52",
      "id": "c4_fn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Worried about losing control of his own increasingly conservative conference, John Rhodes of Arizona, the House minority leader, scrambled to stay in the lead of the parade, though he scoffed at Gingrich’s idea of a coalition-governed House. The fact that Rhodes went out of his way to criticize Gingrich’s notion was a testament to the Georgian’s increasing influence, as well as his uncanny abilities to command attention and get under people’s skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhodes and O’Neill were both fighting off Gingrich, which was bizarre, as he had only been in office a few months. The Speaker and the minority leader had fifty-two years in office between them, having both arrived in Washington as part of the class of 1953.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The national media was paying more and more attention to Gingrich and his band of rebels. By late October 1979, the "), _c('i', [_vm._v("New York Times")]), _vm._v(" ran a major story on him and other back-benchers, which featured a photo of a newly light and lively Newt. Raising cain had obviously consumed a lot of calories:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_vm._v("There was a time when freshmen Congressmen, like obedient children, were seen but never heard on Capitol Hill. However, the current class of Republican newcomers . . . is making a lot of noise and attracting a lot of attention. Many of them are also experts at the use of television, a medium that had helped erode party loyalty and aided the growth of the Republican Party in the Sun Belt. Lawmakers such as Newt Gingrich, the only Republican in the Georgia delegation, have the styled “blow dry” hair that distinguishes TV-age politicians of both parties."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn53",
      "id": "c4_fn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The old guard GOP could not figure out if Gingrich was an asset or just a pain in the neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to their heavy use of blow dryers and hair spray—something appalling to the older members, who favored Brylcreem—the new Republicans were far more conservative than their older counterparts. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_vm._v("And the new Democrats were more liberal. The beginning of the polarization of the two parties—which had started with the 1964 Republican nomination of Barry Goldwater and the 1972 nomination of George McGovern by the Democrats—was accelerating.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The allure of Washington had not turned Gingrich’s head. Yet. Mindful of his tenuous hold on his congressional district, he went back frequently to tend the home fires. There he met with small businesses, conducted town hall meetings, held political fund-raisers, and maintained a high profile in the African American community. According to Mel Steely, a friend and activist, Gingrich was dedicated to the district issues, even leasing a Winnebago to travel and handle constituent services. A young aide was apparently also interested in constituent services. He “was a former student that had become absolutely committed to Newt . . . one time we had people calling us and saying your van is here but we can’t get anybody to answer it . . . it’s bouncing up and down. He’d have his girlfriend in there and was having some recreation during his lunch period.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn54",
      "id": "c4_fn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The youthful driver later offered some marijuana to a reporter and was finally let go. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn55",
      "id": "c4_fn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Only two members of the Georgia congressional delegation supported the Martin Luther King holiday, Congressman Wyche Fowler and Gingrich. He was frequently seen at black churches attending services.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before the Fulton County Republicans, Gingrich ripped the established order in Washington. “We . . . are rapidly moving toward a system where there is one set of laws for the lawmakers . . . and another set for the people. There’s a sense that Congress is a club, which makes different rules for itself.” He scored his new colleagues on Capitol Hill for covering up for corrupt fellow members, for enriching themselves in bypassing Social Security, and for supporting a campaign finance scheme, paid for by the taxpayers, that even the "), _c('i', [_vm._v("Washington Post")]), _vm._v(" labeled a “politicians welfare bill.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn56",
      "id": "c4_fn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One week earlier, Ronald Reagan had paid a visit to the president’s backyard and ripped him and the Democrats in Congress on all manner of things, both foreign and domestic. It was one of the rare appearances the Californian made in 1979, as his campaign operatives were holding him back, fearful that the Gipper might say something that would upset his front-runner status. Still, he signaled his case for a new GOP: “Republicans are the party of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("working people and those who believe in freedom, and we have faith in the marketplace.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn57",
      "id": "c4_fn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Gingrich ended his first year in Congress with an American Conservative Union rating of 89, considered good but not great by the stalwart organization founded in the ashes of the Goldwater campaign of ’64. He ducked a couple of votes on abortion and parental consent for abortions for under aged pregnant girls, and he also voted for the creation of a Department of Education, but on spending and tax-cut votes he was solid. He liked beer and loved ice cream but had no head for Scotch, the preferred drink of Southern gentlemen. When traveling, he would often take twenty-minute power naps and would wake up entirely refreshed and not groggy. As expected, he constantly read and had a near photographic memory. Unfortunately, not everything he memorized was worth remembering. The next year, his ACU rating dipped to 76, considered mediocre by Washington conservatives."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn58",
      "id": "c4_fn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Democrats had a stranglehold on Georgia’s constitutional offices, as well as the legislature; and for the most part they regarded Gingrich as an interloper, a carpetbagger, and a hated Republican. He was the only GOP representative in Georgia’s ten-member House delegation. With the census only one year away, Peach State Democrats began a plot to redistrict Gingrich out of existence after 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Donald Fairchild, a “professor of political science at Georgia State,” said to the United Press International that “state legislators may be tempted to ‘gerrymander’ the 6th District since that seat is now held by the newly elected Rep. Newt Gingrich, the lone Republican in the Georgia delegation and a potential target for the heavily-Democratic General assembly.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn59",
      "id": "c4_fn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Republicans were planning their own counteroffensive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1979, members of Congress could earn outside income from speeches, book royalties, and businesses they may have owned before being elected. Disclosure was required but languidly enforced. Some members had done quite well in 1978. Minority Leader John Rhodes made as much as an additional $85,518 (only a range was required for reporting purposes), while Democrat Phil Gramm of Texas may have pulled in as much as $174,057 "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_vm._v("on top of his congressional salary."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn60",
      "id": "c4_fn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" With the concentration of high-priced lawyers, lobbyists, politicians, and pampered talking heads, it was hard to throw a dart in any direction in Washington and not hit a millionaire.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1978, Gingrich’s household income to support himself, Jackie, and their two daughters had been $10,166, just about coolie wages."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn61",
      "id": "c4_fn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Gingrich never worried much about money and was not allowed to handle the family finances; Jackie did that. As a public schoolteacher, she had brought home the bacon in that election year, yet they lived meagerly, even in rural Georgia; but Congressman Gingrich was now beginning to see opportunities—financial and political—in public speaking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, he was a doting father, reading often with his daughters and taking canoe trips in the Okefenokee Swamp for a week at a time, camping amid the kudzu and the mosquitoes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn62",
      "id": "c4_fn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" He went roller-skating with his daughters, and “I ended up . . . clumsy, not very good at it, clinging to the rail, hoping I won’t fall and hurt myself. And this little four-year-old kid skates backwards past me, looks up and waves. I’ve always used that to remind myself that everybody is good at something.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn63",
      "id": "c4_fn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Gingrich was interested in the new ideas and energy emanating from the Washington GOP. He endorsed a proposal by fellow conservative Dan Quayle of Indiana to grant young, first-time homebuyers a 20 percent tax credit to assist them. “According to the National Association of Home Builders, the cost of buying a median priced new home has risen from $23,400 in 1970 to $67,000 this year.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn64",
      "id": "c4_fn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Quayle’s plan was complicated, but essentially it allowed homebuyers to save money—tax free—until they had enough for a down payment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The name of the bill, the Young Families Homeownership Act,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn65",
      "id": "c4_fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" helped to frame the debate to the Republicans’ advantage. It was one more piece of evidence that the GOP, led by Jack Kemp and others, was emerging as the ideas factory in national politics. Kemp and Gingrich got on well, and the former quarterback journeyed to Atlanta to host a joint fund-raiser with Newt to raise money in advance for Gingrich’s first reelection bid in 1980. Newt gushed, “I have no doubt that one day Kemp will be President of the United States.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn66",
      "id": "c4_fn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" More than four hundred attendees raised more than $20,000 to hear the two young congressmen speak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_vm._v("Gingrich oddly said at one point in his talk that the choice between Reagan and Carter was “nonsense.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn67",
      "id": "c4_fn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Later, as he came to understand the meaning of Reagan, he clearly saw the distinction between his fellow Georgian and the former movie star from California. Reagan, he said, “actually represents the beginning of a different order.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn68",
      "id": "c4_fn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" But, he said, “my model was actually Wellington because he wages the Pennisular campaign with a very small army.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn69",
      "id": "c4_fn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Gingrich was coming to learn that a small motivated force could beat a large, unmotivated force.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometimes his zeal for publicity went too far, though. In late October 1979, he took to the floor of the House and called on the entire House leadership to resign. He also sponsored a bill earlier that would mandate that Congress stay in session during the entire August recess, embarrassing the House leadership on both sides while continuing to make enemies."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn70",
      "id": "c4_fn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" The August recess was sacred to Congress. It was simply an entitlement the self-enhancing members had enjoyed for years, despite their giggle-inducing pleas that these days away from Washington were for work in their respective districts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He also strayed into foreign policy, as when he blasted Carter for not standing firm in supporting the beleaguered Shah of Iran, whose hold on his country was slipping."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn71",
      "id": "c4_fn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" He spun the charge into a patriotic message: Carter’s presidency had done much to undermine America’s prestige in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A year before, nobody could spell his name. Now, Newt Gingrich was mingling with the national powers of politics and media. The year before Congressman-elect Gingrich had been cautious about the trappings of power: “Gradually, they tie up your good sense. They call you ‘congressman.’ They give you this special office. They take care of this; they take care of that. Pretty soon, you actually think you’re important, and you’re not. The job is important. Being the representative is important. The person who does it is just a person.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#c4_rfn72",
      "id": "c4_fn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But by the end of his first year, Congressman Gingrich’s head was being turned.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca93f0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9781595554499_Chapter_4.vue
// module id = 102
// module chunks = 0